export default __webpack_public_path__ + "static/media/Social-Media-page-Header.02790056.png";